const config = {
  env: process.env.REACT_APP_ENV || "production",
  domain: process.env.REACT_APP_DOMAIN || "localhost",

  api: {
    graphql: process.env.REACT_APP_GRAPHQL_API_URL,
    rest: process.env.REACT_APP_REST_API_URL,
    websocket: process.env.REACT_APP_WS_URL,
  },
  google: {
    mapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
  stripe: {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  },
  firebase: {
    vapidKey: process.env.REACT_APP_VAPID_KEY,
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  },
  ads: {
    // Provider selection: 'adsense', 'ezoic', or 'none' to disable ads
    provider: (process.env.REACT_APP_AD_PROVIDER || "adsense") as "adsense" | "ezoic" | "none",
    testMode: process.env.NODE_ENV === "development",
    adInterval: parseInt(process.env.REACT_APP_ADSENSE_AD_INTERVAL || "3", 10), // Show ad every N items
    
    // AdSense configuration
    adsense: {
      enabled: process.env.REACT_APP_AD_PROVIDER === "adsense",
      adClient:
        process.env.REACT_APP_ADSENSE_CLIENT_ID || "ca-pub-xxxxxxxxxxxxxxxx",
      slots: {
        banner: process.env.REACT_APP_ADSENSE_BANNER_SLOT || "1234567890",
        sidebar: process.env.REACT_APP_ADSENSE_SIDEBAR_SLOT || "1234567891",
        inContent: process.env.REACT_APP_ADSENSE_CONTENT_SLOT || "1234567892",
        footer: process.env.REACT_APP_ADSENSE_FOOTER_SLOT || "1234567893",
      },
    },
    
    // Ezoic configuration
    ezoic: {
      enabled: process.env.REACT_APP_AD_PROVIDER === "ezoic",
      placementIds: {
        banner: parseInt(process.env.REACT_APP_EZOIC_BANNER_PLACEMENT || "101", 10),
        sidebar: parseInt(process.env.REACT_APP_EZOIC_SIDEBAR_PLACEMENT || "102", 10),
        inContent: parseInt(process.env.REACT_APP_EZOIC_CONTENT_PLACEMENT || "103", 10),
        footer: parseInt(process.env.REACT_APP_EZOIC_FOOTER_PLACEMENT || "104", 10),
      },
    },
  },
  
  // Legacy: Keep for backward compatibility
  adsense: {
    adClient:
      process.env.REACT_APP_ADSENSE_CLIENT_ID || "ca-pub-xxxxxxxxxxxxxxxx",
    enabled: process.env.REACT_APP_AD_PROVIDER === "adsense",
    testMode: process.env.NODE_ENV === "development",
    adInterval: parseInt(process.env.REACT_APP_ADSENSE_AD_INTERVAL || "3", 10),
    slots: {
      banner: process.env.REACT_APP_ADSENSE_BANNER_SLOT || "1234567890",
      sidebar: process.env.REACT_APP_ADSENSE_SIDEBAR_SLOT || "1234567891",
      inContent: process.env.REACT_APP_ADSENSE_CONTENT_SLOT || "1234567892",
      footer: process.env.REACT_APP_ADSENSE_FOOTER_SLOT || "1234567893",
    },
  },
  featureFlags: {
    // Controls whether paid event creation is restricted to admin users only
    // When true: only admin users can create paid events (ignores subscription permissions)
    // When false: uses subscription-based permissions (current behavior)
    paidEventsAdminOnly: process.env.REACT_APP_PAID_EVENTS_ADMIN_ONLY_FF === "true",
    // Controls whether Satispay is offered as a subscription payment method (in addition to
    // cards). Lets Satispay ship code-dark and be enabled independently of a deploy once the
    // Stripe Dashboard live-mode setup is ready.
    satispayEnabled: process.env.REACT_APP_SATISPAY_ENABLED_FF === "true",
  },
};

export default config;
